/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Show.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import ActivateAction from './ActivateAction/logic.js'
import BenefitTerminationDate from './BenefitTerminationDate/view.js'
import BenefitTerminationReason from './BenefitTerminationReason/view.js'
import City from './City/view.js'
import CloseAction from './CloseAction/view.js'
import ContactFirstName from './ContactFirstName/view.js'
import ContactLastName from './ContactLastName/view.js'
import CreatedAt from './CreatedAt/view.js'
import DateOfBirth from './DateOfBirth/view.js'
import Dependents from './Dependents/logic.js'
import EditAction from './EditAction/view.js'
import EffectiveDate from './EffectiveDate/view.js'
import Email from './Email/view.js'
import ExpiryDate from './ExpiryDate/view.js'
import FirstName from './FirstName/view.js'
import LastName from './LastName/view.js'
import LastPaymentDate from './LastPaymentDate/view.js'
import LastPaymentInvoice from './LastPaymentInvoice/view.js'
import LastPaymentNote from './LastPaymentNote/view.js'
import LastPaymentStatus from './LastPaymentStatus/view.js'
import MaritalStatus from './MaritalStatus/view.js'
import MemberId from './MemberId/view.js'
import MembersCovered from './MembersCovered/view.js'
import ModalContent from 'DesignSystem/ModalContent/view.js'
import ModalHeader from 'DesignSystem/ModalHeader/view.js'
import PaymentDetails from './PaymentDetails/logic.js'
import PhoneNumber from './PhoneNumber/view.js'
import PlanType from './PlanType/view.js'
import Professional from './Professional/logic.js'
import ProviderLocation from './ProviderLocation/logic.js'
import React from 'react'
import SocialSecurityNumber from './SocialSecurityNumber/view.js'
import State from './State/view.js'
import Status from './Status/view.js'
import Street from './Street/view.js'
import SubTitle from 'DesignSystem/SubTitle/view.js'
import SubscriptionStatus from './SubscriptionStatus/logic.js'
import TerminateAction from './TerminateAction/logic.js'
import TotalPlanCost from './TotalPlanCost/view.js'
import UpdatedAt from './UpdatedAt/view.js'
import Zip from './Zip/view.js'
import { css } from "emotion"
ActivateAction.displayName = 'ActivateActionLogic'
Dependents.displayName = 'DependentsLogic'
PaymentDetails.displayName = 'PaymentDetailsLogic'
Professional.displayName = 'ProfessionalLogic'
ProviderLocation.displayName = 'ProviderLocationLogic'
SubscriptionStatus.displayName = 'SubscriptionStatusLogic'
TerminateAction.displayName = 'TerminateActionLogic'

let styles = {}
styles.Horizontal = css({label: 'Horizontal',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal1 = css({label: 'Horizontal1',
  flexDirection: "row"})
styles.Horizontal2 = css({label: 'Horizontal2',
  flexDirection: "row"})
styles.Horizontal3 = css({label: 'Horizontal3',
  flexDirection: "row"})
styles.Horizontal4 = css({label: 'Horizontal4',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal5 = css({label: 'Horizontal5',
  flexDirection: "row"})
styles.Horizontal6 = css({label: 'Horizontal6',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal7 = css({label: 'Horizontal7',
  flexDirection: "row"})
styles.Horizontal8 = css({label: 'Horizontal8',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal9 = css({label: 'Horizontal9',
  flexDirection: "row"})
styles.Horizontal10 = css({label: 'Horizontal10',
  flexDirection: "row"})
styles.Horizontal11 = css({label: 'Horizontal11',
  flexDirection: "row"})
styles.Horizontal12 = css({label: 'Horizontal12',
  flexDirection: "row",
marginTop: 16})
styles.Horizontal13 = css({label: 'Horizontal13',
  flexDirection: "row"})

export default function Show({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<ModalHeader
 data-testid="Show.ModalHeader"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/ModalHeader`}
 text="Individual Member details"
>
{childProps => (
<React.Fragment>
<TerminateAction
{...childProps}
 data-testid="Show.TerminateAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/TerminateAction`}
/>
<ActivateAction
{...childProps}
 data-testid="Show.ActivateAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/ActivateAction`}
/>
<EditAction
{...childProps}
 data-testid="Show.EditAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/EditAction`}
/>
<CloseAction
{...childProps}
 data-testid="Show.CloseAction"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/CloseAction`}
/>
</React.Fragment>
)}
</ModalHeader>
<ModalContent
 data-testid="Show.ModalContent"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/ModalContent`}
>
{childProps => (
<React.Fragment>
<SubTitle
{...childProps}
 data-testid="Show.SubTitle"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubTitle`}
 text="Account"
/>
<div
 data-testid="Show.Horizontal"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal}`}
>
<Status
 data-testid="Show.Status"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/Status`}
/>
<MemberId
 data-testid="Show.MemberId"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/MemberId`}
/>
<SubscriptionStatus
 data-testid="Show.SubscriptionStatus"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubscriptionStatus`}
/>
</div>
<div
 data-testid="Show.Horizontal:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal1}`}
>
<LastPaymentDate
 data-testid="Show.LastPaymentDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/LastPaymentDate`}
/>
<LastPaymentStatus
 data-testid="Show.LastPaymentStatus"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/LastPaymentStatus`}
/>
</div>
<div
 data-testid="Show.Horizontal:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal2}`}
>
<LastPaymentNote
 data-testid="Show.LastPaymentNote"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/LastPaymentNote`}
/>
</div>
<div
 data-testid="Show.Horizontal:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal3}`}
>
<LastPaymentInvoice
 data-testid="Show.LastPaymentInvoice"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/LastPaymentInvoice`}
/>
<PaymentDetails
 data-testid="Show.PaymentDetails"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/PaymentDetails`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Show.SubTitle:1"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubTitle`}
 marginTop={32}
 text="Personal"
/>
<div
 data-testid="Show.Horizontal:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal4}`}
>
<FirstName
 data-testid="Show.FirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/FirstName`}
/>
<LastName
 data-testid="Show.LastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/LastName`}
/>
</div>
<div
 data-testid="Show.Horizontal:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal5}`}
>
<DateOfBirth
 data-testid="Show.DateOfBirth"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/DateOfBirth`}
/>
<MaritalStatus
 data-testid="Show.MaritalStatus"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/MaritalStatus`}
/>
<SocialSecurityNumber
 data-testid="Show.SocialSecurityNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SocialSecurityNumber`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Show.SubTitle:2"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubTitle`}
 marginTop={32}
 text="Contact"
/>
<div
 data-testid="Show.Horizontal:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal6}`}
>
<ContactFirstName
 data-testid="Show.ContactFirstName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/ContactFirstName`}
/>
<ContactLastName
 data-testid="Show.ContactLastName"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/ContactLastName`}
/>
</div>
<div
 data-testid="Show.Horizontal:7"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal7}`}
>
<PhoneNumber
 data-testid="Show.PhoneNumber"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/PhoneNumber`}
/>
<Email
 data-testid="Show.Email"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/Email`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Show.SubTitle:3"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubTitle`}
 marginTop={32}
 text="Benefit"
/>
<div
 data-testid="Show.Horizontal:8"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal8}`}
>
<PlanType
 data-testid="Show.PlanType"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/PlanType`}
/>
<EffectiveDate
 data-testid="Show.EffectiveDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/EffectiveDate`}
/>
<ExpiryDate
 data-testid="Show.ExpiryDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/ExpiryDate`}
/>
</div>
<div
 data-testid="Show.Horizontal:9"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal9}`}
>
<CreatedAt
 data-testid="Show.CreatedAt"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/CreatedAt`}
/>
<UpdatedAt
 data-testid="Show.UpdatedAt"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/UpdatedAt`}
/>
</div>
<div
 data-testid="Show.Horizontal:10"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal10}`}
>
<BenefitTerminationDate
 data-testid="Show.BenefitTerminationDate"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/BenefitTerminationDate`}
/>
<BenefitTerminationReason
 data-testid="Show.BenefitTerminationReason"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/BenefitTerminationReason`}
/>
</div>
<div
 data-testid="Show.Horizontal:11"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal11}`}
>
<MembersCovered
 data-testid="Show.MembersCovered"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/MembersCovered`}
/>
<TotalPlanCost
 data-testid="Show.TotalPlanCost"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/TotalPlanCost`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Show.SubTitle:4"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubTitle`}
 marginTop={32}
 text="Address"
/>
<div
 data-testid="Show.Horizontal:12"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal12}`}
>
<City
 data-testid="Show.City"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/City`}
/>
<Street
 data-testid="Show.Street"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/Street`}
/>
</div>
<div
 data-testid="Show.Horizontal:13"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
 className={`views-block ${styles.Horizontal13}`}
>
<State
 data-testid="Show.State"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/State`}
/>
<Zip
 data-testid="Show.Zip"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/Zip`}
/>
</div>
<SubTitle
{...childProps}
 data-testid="Show.SubTitle:5"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubTitle`}
 marginTop={32}
 text="Primary Care Location"
/>
<ProviderLocation
{...childProps}
 data-testid="Show.ProviderLocation"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/ProviderLocation`}
/>
<Professional
{...childProps}
 data-testid="Show.Professional"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/Professional`}
/>
<SubTitle
{...childProps}
 data-testid="Show.SubTitle:6"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/SubTitle`}
 marginTop={50}
 text="Dependents"
/>
<Dependents
{...childProps}
 data-testid="Show.Dependents"
 data-view-path="/App/MyAccount/Content/Profile/Content/Individuals/Item/Content/Show"
viewPath={`${viewPath}/Dependents`}
/>
</React.Fragment>
)}
</ModalContent>
{children}
</React.Fragment>)
}